/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
'use client';

import * as Label from '@radix-ui/react-label';
import React from 'react';
import { tv, type VariantProps } from 'tailwind-variants';
import { cn } from '@/app_lib/utils/utils';

const label = tv({
  base: 'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  variants: {
    variant: {
      required: 'label-required',
    },
  },
});

interface LabelProps extends React.ComponentPropsWithoutRef<typeof Label.Root>, VariantProps<typeof label> {
  required?: boolean;
}

const Root = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, variant, ...rest }, ref) => {
  return (
    <Label.Root
      className={cn(label({ variant }), className)}
      ref={ref}
      {...rest}
    />
  );
});
Root.displayName = 'Label';

export { Root };
